import { ContentSaveCogOutlineIcon } from './ContentSaveCogOutlineIcon';

/**
 * author: Michael Irigoyen
 * id A145BFEF-B18C-49C5-B24C-7918C878307E
 * name content-save-cog-outline
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/content-save-cog-outline.svg
 * tags
 * - Settings 
 */
export const FloppyDiscCogOutlineIcon = ContentSaveCogOutlineIcon;
export default FloppyDiscCogOutlineIcon